<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-2">MAKLUMAT PENGIRAAN</h3>
                    <validation-provider name="AmaunTelahTerima" :rules="{ required: true }" v-slot="validationContext">
                        <b-row class="my-1">
                            <b-col lg='3'>Amaun Dalam Buku Servis:</b-col>
                            <b-col lg='1'>:</b-col>
                            <b-col lg='2'>
                                <base-input type="text" v-model="Obj.AmaunTelahTerima" />
                            </b-col>
                        </b-row>
                    </validation-provider>
                    <validation-provider name="catatan" :rules="{ required: true }" v-slot="validationContext">
                        <b-row class="my-1">
                            <b-col lg='3'>Catatan:</b-col>
                            <b-col lg='1'>:</b-col>
                            <b-col lg='8'>
                                <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>

                            </b-col>
                        </b-row>
                    </validation-provider>
                    <br />
                    <b-row class="my-1">
                        <b-col lg='3'></b-col>
                        <b-col lg='1'></b-col>
                        <b-col lg='2'>
                            <b-button variant="success" type="submit">SIMPAN</b-button>
                        </b-col>
                    </b-row>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun", "elemenId"],
    data() {
        return {

           Obj: {
                Catatan: `Pengiraan Gaji KUP oleh Pegawai Bahagian Gaji Elaun`,
            },

        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId = this.elemenId;
            console.log("log", this.Obj);

            GetsalaryService.setElemenCalcBGE(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        }

    },
    created() {

    }
}
</script>

<style scoped>
.custom-input {
    /* Gaya tambahan untuk input jika diperlukan */
}

.custom-input-large {
    font-size: 1.25rem;
    /* Atur ukuran font lebih besar */
    padding: .75rem 1.5rem;
    /* Sesuaikan padding input */
    height: auto;
    /* Sesuaikan tinggi input */
}
</style>
